import './ui.css';

/** Capability bullet list. Checkmarks are drawn in CSS, so no icon font. */
const CheckList = ({ items, columns = false, className = '' }) => (
  <ul
    className={`check-list${columns ? ' check-list--cols' : ''} ${className}`.trim()}
  >
    {items.map((item) => (
      <li key={typeof item === 'string' ? item : item.key}>{item}</li>
    ))}
  </ul>
);

export default CheckList;
